module.exports = __webpack_public_path__ + "static/social-thumb-bb4c7d33edee062fd1fa3e502aa570c4.jpg";